import './index.scss';

import CropImageModal from '../modals/crop_image_modal/index';
import { EventManager } from 'utils/event_manager';

class AvatarUploadInput {
  constructor(context) {
    this.$context = $(context);
    this.$input = $('[type="hidden"]', this.$context);
    this.$fileInput = $('[type="file"]', this.$context);
    this.$previewImg = $('img', this.$context);
    this.errors = [];
    this.bind();
  }

  set state(value) {
    this.$context.data('state', value);
    this.$context.attr('data-state', value);
  }

  set inputValue(value) {
    this.$input.val(value);
  }

  get selectedFile() {
    return this.$fileInput.get(0).files[0];
  }

  get selectedFileExtension() {
    return this.selectedFile.name.split('.').pop();
  }

  get uploadPath() {
    return this.$context.data('upload-path');
  }

  get currentImageUrl() {
    return this.$context.data('current-image-url');
  }

  generateUploadFileName() {
    return `${this.uploadPath}avatar-${this.generateId()}.png`;
  }

  bind() {
    this.$fileInput.on('change', this.onFileChange.bind(this));
  }

  async onFileChange() {
    this._validateFile();

    if (this.errors.length > 0) {
      toastr.error(this.errors.pop());
      return;
    }

    EventManager.publish('avatar_upload.start');
    this.state = 'uploading';
    this.showCropModal();
  }

  async getPresignedPostData(fileName) {
    return await $.ajax({
      url: gon.avatar_presign_url,
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify({
        bucket: gon.avatar_bucket,
        key: fileName,
        content_type: 'image/png',
        acl: 'public-read'
      })
    });
  }

  async uploadToS3(presignedPostData, blob) {
    const formData = new FormData();
    Object.keys(presignedPostData.fields).forEach(key => {
      formData.append(key, presignedPostData.fields[key]);
    });
    formData.append('file', blob);
    await $.ajax({
      url: presignedPostData.url,
      type: 'POST',
      data: formData,
      cache: false,
      processData: false,
      contentType: false
    });
  }

  generateId() {
    return new Date().getTime().toString(36);
  }

  showCurrentImage() {
    this.$previewImg.attr('src', this.currentImageUrl);
  }

  readFile() {
    return new Promise(resolve => {
      const reader = new FileReader();

      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(this.selectedFile);
    });
  }

  async showCropModal() {
    const base64 = await this.readFile();
    const cropModal = new CropImageModal(base64, this.upload.bind(this), this.reset.bind(this));
    cropModal.show();
  }

  setPreview(dataURL) {
    this.$previewImg.attr('src', dataURL);
  }

  async upload(blob, dataURL) {
    try {
      await this.uploadFromPresignedData(blob);
      this.afterUpload(dataURL);
    } catch (ex) {
      this.state = 'initial';
      this.showCurrentImage();

      toastr.error('Tivemos um problema ao tentar enviar sua foto!');
      Rollbar.error('Profile avatar upload error', ex);
      EventManager.publish('avatar_upload.ended');
    }
  }

  async uploadFromPresignedData(blob) {
    this.fileName = this.generateUploadFileName();
    const presignedPostData = await this.getPresignedPostData(this.fileName);
    await this.uploadToS3(presignedPostData, blob);
  }

  afterUpload(dataURL) {
    this.inputValue = this.fileName;
    this.state = 'uploaded';
    EventManager.publish('avatar_upload.ended');
    this.setPreview(dataURL);
  }

  reset() {
    this.$fileInput.val('');
    EventManager.publish('avatar_upload.ended');
    this.state = 'initial';
  }

  _validateFile() {
    if (this._isInvalidExtension()) {
      this.errors.push(
        'Este formato de arquivo não é suportado. Por favor, utilize arquivos no formato png, jpg, jpge ou gif.'
      );
    }

    if (this._isInvalidSize()) {
      this.errors.push(
        'Este arquivo excede o tamanho suportado. Por favor, utilize um arquivo com tamanho máximo de 2 MB.'
      );
    }
  }

  _isInvalidSize() {
    const maxBytes = 2000000;
    return this.selectedFile.size > maxBytes;
  }

  _isInvalidExtension() {
    const supportedFormats = ['jpg', 'png', 'gif', 'jpeg'];
    return !supportedFormats.includes(this.selectedFileExtension);
  }
}

(function ($) {
  $('.js-avatar-upload').each((i, el) => {
    el.avatarUpload = new AvatarUploadInput(el);
  });
})(jQuery);
